import React, { Component } from 'react';
//import Config from './Config';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/ProductAllocation.css';
import FX from './functions/functions';



class ProductAllocation extends Component {
  constructor(props) {
    super(props);
    this.state = { allocation:[] };
  }
  search = () => {
    var search_str;
    if(document.getElementById("search_text")){
      search_str = document.getElementById("search_text").value;
    }
    console.log(search_str);
  }
  componentDidUpdate(prevProps, prevState, snapshot){
    if(this.props.product_id != prevProps.product_id){
        var data = {customer_id: this.props.root.state.customer_id, product_id: this.props.product_id};
        var qs = FX.encodeQueryData(data, true);
        FX.load(this.props.root,'product_allocation' + qs , (res, i) => {
          console.log(res);
          this.setState({allocation:res});
        });
          
    }
  }

  componentWillMount(){
    console.log('Here I come');
    console.log(this.props.product_id);
    var data = {customer_id: this.props.root.state.customer_id, product_id: this.props.product_id};
    var qs = FX.encodeQueryData(data, true);
    FX.load(this.props.root,'product_allocation' + qs , (res, i) => {
      console.log(res);
      this.setState({allocation:res});
    });
  }
  componentWillUnmount(){
    console.log('Here I go');
    console.log(this.props.product_id)
  }
  showMenu = () => {
    this.props.root.setState({menu_show: !this.props.root.state.menu_show});
  }
  render() {
    var className;
    var alloc = this.state.allocation.map (ac => {
      var dispatch_status;
      var icon;
      if(ac.dispatch.dispatch_status >= 10){
        dispatch_status = 'reserved';
        icon = <i className="fa fa-check-circle reserved" aria-hidden="true" />
      }
      else {
        dispatch_status = ''
      }
      return (<tr onClick={FX.navigate.bind(this.props.root, 'dispatches'  , undefined ,'/dispatches/'+ac.dispatch.id)} className={dispatch_status}><td><i className="fa fa-cube" aria-hidden="true" /></td><td className="move_ref">{ac.dispatch.reference}</td><td>{ac.dispatch_item.quantity}{icon}</td></tr>);
    })
    if(!alloc.length){
      alloc = <div className="empty">[None]</div>
    }
    return (
      <div className={className} id="ProductAllocation">
        <div className="title">Product Allocations</div>
        <div className="itemList">
          <table>
            {alloc}
          </table>
        </div>
      </div>
    );
  }
}

export default ProductAllocation;



// WEBPACK FOOTER //
// ./src/ProductAllocation.js